import { Input } from "@vds/inputs";
import {
  CVAPP_DWELLTIME,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PROXIMITY,
  CVAPP_UNOBJECTDETECTION,
} from "../constants/cvappConstants";

const NumberInput = ({
  label,
  width,
  isError,
  setIsError,
  min = 0,
  max = 99999,
  value,
  onChange,
  readOnly = false,
  appName = "",
  required = true,
  helperText,
  helperBottom,
  helperTextPlacement,
  errorText = appName === CVAPP_UNOBJECTDETECTION || appName === CVAPP_DWELLTIME
    ? "Please enter a value between 1 and 99999(inclusive)"
    : appName === CVAPP_PROXIMITY
    ? " "
    : appName === CVAPP_PARKINGOCCUPANCYEE ||
      appName === CVAPP_PARKINGOCCUPANCYOA
    ? "Please enter a value between 1 and 100(inclusive)"
    : `Please enter a value between ${min} and ${max}(inclusive)`,
  children = "",
  title = "",
  disallowZero = false,
  type="text",
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Always display the entered value
    if (onChange) {
      onChange(inputValue);
    }
    // Handle empty value
    if (disallowZero && (inputValue === "" || inputValue === "0")) {
      setIsError(true);
      return;
    }
    if (!/^\d*$/.test(inputValue)) {
      setIsError(true);
      return;
    }
    if (
      (appName !== CVAPP_UNOBJECTDETECTION &&
        appName !== CVAPP_DWELLTIME &&
        appName !== CVAPP_PARKINGOCCUPANCYEE &&
        appName !== CVAPP_PARKINGOCCUPANCYOA &&
        inputValue == "0")
    ) {
      setIsError(false);
    } else {
      const numberValue = parseInt(inputValue, 10);
      if (appName == CVAPP_UNOBJECTDETECTION && inputValue == "0") {
        setIsError(true);
      } else if (numberValue >= min && numberValue <= max) {
        setIsError(false);
      } else {
        setIsError(true);
      }
    }
  };

  return (
    <Input
      type={type}
      label={label}
      width={width}
      min={min}
      max={max}
      error={isError}
      onChange={handleChange}
      value={value}
      readOnly={readOnly}
      required={required}
      errorText={
        isError && !/^\d*$/.test(value) ? "Enter a valid number" : errorText
      }
      helperText={helperText ? helperText : ""}
      helperBottom={helperBottom ? helperBottom : ""}
      helperTextPlacement={helperTextPlacement}
      tooltip={{
        title: title,
        children: children,
      }}
    />
  );
};

export default NumberInput;
